import '@css/main.scss'
import 'swiper/css'
import 'swiper/css/pagination'

import '@spectrum-web-components/theme/sp-theme.js';
import '@spectrum-web-components/theme/src/express/themes.js';
import '@spectrum-web-components/field-label/sp-field-label.js';
import '@spectrum-web-components/combobox/sp-combobox.js';


// Utilities
import './_utilities/alpine'

// Parts
import './_parts/navigation/doorways-slider'
import './_parts/home/doorways-slider'

import './register-demo'

// Forms
const forms = document.querySelectorAll<HTMLElement>('.form__wrapper')
if (forms) {
  import('./_parts/forms').then((module) => {
    new module.default(forms)
  })
}

// Registration Form
const registrationForm =
  document.querySelector<HTMLFormElement>('form#register-form')
if (registrationForm) {
  import('./registration-form').then((module) => {
    new module.default(registrationForm)
  })
}

// Blocks
const cookiebotVideos = document.querySelectorAll<HTMLElement>(
  '.cookiebot-video__wrapper'
)

if (cookiebotVideos.length) {
  import('./_parts/cookiebot-video').then((module) => {
    new module.default(cookiebotVideos)
  })
}

const imageSliders = document.querySelectorAll<HTMLElement>('.image-slider')

if (imageSliders.length) {
  import('./_blocks/image-slider').then((module) => {
    new module.default(imageSliders)
  })
}
